/* PMY 2026-10-02: header country/service compatibility. Hero slideshow is owned by pmy-service-country-bridge-core.js. */
(function(){
  'use strict';
  if(window.__PMY_HEADER_MOBILE_HOTFIX__)return;
  window.__PMY_HEADER_MOBILE_HOTFIX__=true;

  function safeSetCountryPortugal(){
    try{
      localStorage.setItem('pmy_home_country','portugal');
      localStorage.setItem('pmy_daytrip_destination','portugal');
      localStorage.setItem('pmy_home_destination','portugal');
    }catch(e){}
  }

  document.addEventListener('click',function(event){
    var button=event.target&&event.target.closest?event.target.closest('.main-header-wrapper .pmy-platform-vertical[data-service]'):null;
    if(!button)return;
    var service=button.getAttribute('data-service')||'';
    if(service==='tours')return;
    var header=button.closest('.main-header-wrapper');
    if(!header)return;
    var italy=header.classList.contains('pmy-header-country-italy')||header.getAttribute('data-pmy-country')==='italy';
    if(!italy)return;
    safeSetCountryPortugal();
    header.classList.remove('pmy-header-country-italy');
    header.setAttribute('data-pmy-country','portugal');
  },true);
})();